import { createAction, union } from '@ngrx/store';
import { LoadingState } from '../restaurant/restaurant.reducer';

export const updateLoadingState = createAction(
  'WithdrawActions updateLoadingState',
  (payload: LoadingState) => ({ payload }),
);

const all = union({
  updateLoadingState,
});
export type WithdrawActionsUnion = typeof all;
